import { parseURLParams } from '../util';

export * from './functions';

export function parseJWTFromURLParams(url: URL = window.location) {
    if(window.config.iAmRecorder) {
        delete window.Token;
    }
    return parseURLParams(url, true, 'search').jwt || window.Token;
}